import { Component } from '@angular/core';

import { JanelaComponent } from './../janela/janela.component';

@Component({
  selector: 'manipula-cadastro',
  templateUrl: './manipula-cadastro.component.html',
  styleUrls: ['./manipula-cadastro.component.scss'],
})
export class ManipulaCadastroComponent  extends JanelaComponent {

}




// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/manipula-cadastro/manipula-cadastro.component.ts